"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const i18next_1 = __importDefault(require("i18next"));
function default_1() {
    const [isCapsLockOn, setIsCapsLockOn] = (0, react_1.useState)(false);
    const detectCapsLock = (e) => {
        const isCapsLock = e.getModifierState('CapsLock');
        setIsCapsLockOn(isCapsLock);
    };
    const capsLockErrorMsg = isCapsLockOn ? i18next_1.default.t('Caps Lock이 켜져있습니다') : '';
    return { capsLockErrorMsg, detectCapsLock };
}
exports.default = default_1;
